import { Scene, AbstractMesh, ArcRotateCamera, Mesh, DirectionalLight, Vector3, TransformNode, SpriteManager, Sprite, ShadowGenerator, Texture, PBRMaterial, CubeTexture, PointerEventTypes } from '@babylonjs/core';
import { ModelLoader } from '../loader/ModelLoader';
import { BaseStage } from './BaseStage';
import { CsmShadow } from '../materials/shadow/CsmShadow';
import { BabylonTools } from '../utils/BabylonTools';
import { HotPoint } from '../displayObject/UI/HotPoint';
import { FaultPoint } from '../displayObject/UI/FaultPoint';
import { MaintainPoint } from '../displayObject/UI/MaintainPoint';
import { ProcessPoint } from './../displayObject/UI/ProcessPoint';
import { WarnPoint } from './../displayObject/UI/WarnPoint';
import { HoldPoint } from './../displayObject/UI/HoldPoint';
import { ShutdownPoint } from './../displayObject/UI/ShutdownPoint';
import { NaviMinimap } from '../displayObject/UI/NaviMinimap';
import { FacilityInfo } from '../displayObject/UI/FacilityInfo';
import { GlobalObject } from '../utils/GlobalObject';
import { Boardcaster } from '../event/Boadcaster';
import { CrossEvent } from './../event/CrossEvent';

export class CLianheStage extends BaseStage {
    protected scene: Scene;
    private temp: any;
    private groundMesh?: AbstractMesh | null;
    private workshopMesh?: AbstractMesh | null;
    private houseMesh?: AbstractMesh | null;
    private boxMesh?: AbstractMesh | null;
    private camMesh?: AbstractMesh | null;
    private fancilityMesh?: AbstractMesh | null;
    private camArr?: Sprite[] = [];
    private nowCamObj?: any;
    private source?: any;
    private nowDate: Date = new Date();
    private groundAO?:Texture;
    private groundShadow?: Texture;
    private ground_0?: Mesh;
    private mc: TransformNode;
    private stageShowed:boolean = true;
    private minimap?:NaviMinimap;
    private facilityInfoBox?: FacilityInfo;
    private viewPositions = [new Vector3(-21, 0.9, 140), new Vector3(-75, 0.9, 116), new Vector3(47, 0.9, 140), new Vector3(-18, 150, 116), new Vector3(-21, 7, 140)];
    private viewSetting = [[-6.26, 1.36], [3.167, 1.36], [0.12, 1.31], [Math.PI * 0.5, 0], [-6.26, 1.1]];
    private playerData = { pos: this.viewPositions[1], view: this.viewSetting[1] };

    constructor(scene: Scene) {
        super(scene);
        this.scene = scene;
        this.source = GlobalObject.getInstance().main.source.lianhe;
        this.mc = new TransformNode("mc_c", this.scene);
        this.temp = GlobalObject.getInstance().main.temp as any;
        this.loadModels();
        this.init();
        //consolog dev-tool test
        this.temp.reload = this.reload.bind(this);
        this.temp.unload = this.unload.bind(this);
    }
    private init() {
        const playerObj = GlobalObject.getInstance().main.player as any;
        const camera = (GlobalObject.getInstance().main.camera as ArcRotateCamera);
        Boardcaster.getInstance().setStage(this);
        if (GlobalObject.getInstance().main.stageName && GlobalObject.getInstance().main.stageName == "CLianheStageEquipment") {
            // 从设备详情进入
            const player = playerObj.player as Mesh;
            player.position = this.playerData.pos;
            const camera = (GlobalObject.getInstance().main.camera as ArcRotateCamera);
            camera.alpha = this.playerData.view[0];
            camera.beta = this.playerData.view[1];
            playerObj.locked = false;
        } else {
            this.onViewAngleChanged(0);
        }
        GlobalObject.getInstance().setStageName("CLianheStage");
        GlobalObject.getInstance().main.skybox?.setIndoorSkybox();
        GlobalObject.getInstance().setCamSpeed(0.1); // shift漫游速度
        playerObj.speedNum = 0.1;
        camera.upperRadiusLimit = 0.5;
        camera.minZ = 0.2;
        camera.maxZ = 250;
        camera.fov = 0.3 * Math.PI;
        this.showMinimap();
    }
    private async loadModels() {
        let loader = ModelLoader.instance;
        
        this.houseMesh = await loader.getModel(this.source.house);
        this.houseMesh?.setEnabled(this.stageShowed);
        this.workshopMesh = await loader.getModel(this.source.workshop);
        this.workshopMesh?.setEnabled(this.stageShowed);
        
        this.groundMesh = await loader.getModel(this.source.ground);
        this.groundMesh?.setEnabled(this.stageShowed);

        this.boxMesh = await loader.getModel(this.source.box, 0);
        this.boxMesh?.setEnabled(this.stageShowed);
        
        this.camMesh = await loader.getModel(this.source.camMesh);
        //--this.camMesh?.position.set(120, 0, -76);
        this.fancilityMesh = await loader.getModel(this.source.fancilityMesh);
        //this.groundAO = new Texture(this.source.ao, this.scene);
        //this.ground_0 = this.groundMesh?.getChildMeshes()[0] as Mesh;
        //(this.ground_0.material as PBRMaterial).ambientTexture = this.groundAO;

        this.createShadowAndPhysics();
        this.createCam();
        this.createFancility();
        //this.showPoints();
        this.addPickEvent();
        this.camEanbled(this.stageShowed); // 如果代码运行到这里时，已经切换到其他车间
    }
    private createShadowAndPhysics() {
        let collider = this.boxMesh?.getChildren().filter((item) => { return item.name == 'collider_lh' })[0];
        collider?.getChildren().forEach((c) => {
            if (c instanceof Mesh) {
                c.checkCollisions = true;
                c.isPickable = false;
            }
        });
        this.scene.addMesh(this.boxMesh as AbstractMesh);
        // 让物体不可点击(方便点中热点)
        this.workshopMesh?.getChildMeshes().forEach((c) => {
            c.isPickable = false;
        });
    }
    public createFancility() {
        this.clearFancility();
        let m: Mesh[] = this.fancilityMesh?.getChildMeshes() as Mesh[];
        let fancilityData: any[] = GlobalObject.getInstance().main.fancilityData;
        let subfancilityObj: any = {};
        // 先得到设备状态
        m.forEach((c) => {
            if (c.name.substring(0, 2) == '_0') {
                let id = c.name.substring(1, 8).replace("_", "-");
                subfancilityObj[id] = "无状态";
                //console.log(id,c.name.substring(0, 2),c.name);
                let obj = fancilityData.find((v) => id.indexOf(v.macno) > -1);
                if (obj) {
                    //let r = obj.wostatusname == '正常' ? 1 : obj.wostatusname == '维修中' ? 2 : 3;
                    subfancilityObj[id] = obj.wostatusname;
                }
            }
        });

        console.log(subfancilityObj);

        //再显示状态信息
        let hp = GlobalObject.getInstance().main.HotPoint as HotPoint;
        let fp = GlobalObject.getInstance().main.fp as FaultPoint;
        let mp = GlobalObject.getInstance().main.mp as MaintainPoint;
        let pp = GlobalObject.getInstance().main.pp as ProcessPoint;
        let wp = GlobalObject.getInstance().main.wp as WarnPoint;
        let hop = GlobalObject.getInstance().main.hop as HoldPoint;
        let sp = GlobalObject.getInstance().main.sp as ShutdownPoint;
        m.forEach((c) => {
            let bboxCenter = c.getBoundingInfo().boundingBox.centerWorld;
            let pos: Vector3 = new Vector3(bboxCenter.x, bboxCenter.y, bboxCenter.z);
            let id = c.name.substring(c.name.length - 7, c.name.length).replace("_", "-");
            c.visibility = 0;
            if (!subfancilityObj[id] || subfancilityObj[id] == "无状态") {
                c.visibility = 0;
                return;
            }
            console.log(subfancilityObj[id]);
            switch (subfancilityObj[id]) {
                case "正常":
                    // 正常
                    let point = hp.getObject() as any;
                    point.name = "fan" + c.name;
                    point.metadata = {};
                    point.metadata.class = hp;
                    point.setParent(this.mc as TransformNode);
                    point.setEnabled(true);
                    point.position = pos.clone();
                    point.scaling.set(0.5, 0.5, 0.5);
                    hp.addAnimation(point.getChildren()[0] as Mesh);
                    break;
                case "故障":
                    // 故障
                    let pt = fp.getObject() as Mesh;
                    pt.name = "fan" + c.name;
                    pt.metadata = {};
                    pt.metadata.class = fp;
                    pt.setParent(this.mc as TransformNode);
                    pt.setEnabled(true);
                    pt.position = pos.clone();
                    console.log(pt);
                    break;
                case "维修中":
                    // 维修
                    let mt = mp.getObject() as Mesh;
                    mt.name = "fan" + c.name;
                    mt.metadata = {};
                    mt.metadata.class = mp;
                    mt.setParent(this.mc as TransformNode);
                    mt.setEnabled(true);
                    mt.position = pos.clone();
                    break;
                case "加工":
                    let prt = pp.getObject() as Mesh;
                    prt.name = "fan" + c.name;
                    prt.metadata = {};
                    prt.metadata.class = pp;
                    prt.setParent(this.mc as TransformNode);
                    prt.setEnabled(true);
                    prt.position = pos.clone();
                    break;
                case "报警":
                    let wt = wp.getObject() as Mesh;
                    wt.name = "fan" + c.name;
                    wt.metadata = {};
                    wt.metadata.class = wp;
                    wt.setParent(this.mc as TransformNode);
                    wt.setEnabled(true);
                    wt.position = pos.clone();
                    break;
                case "待机":
                    let ht = hop.getObject() as Mesh;
                    ht.name = "fan" + c.name;
                    ht.metadata = {};
                    ht.metadata.class = hop;
                    ht.setParent(this.mc as TransformNode);
                    ht.setEnabled(true);
                    ht.position = pos.clone();
                    break;
                default:
                    // 关机
                    let st = sp.getObject() as Mesh;
                    st.name = "fan" + c.name;
                    st.metadata = {};
                    st.metadata.class = sp;
                    st.setParent(this.mc as TransformNode);
                    st.setEnabled(true);
                    st.position = pos.clone();
                    break;
            }
        });
    }
    private clearFancility() {
        let arr = this.mc.getChildren();
        if (arr && arr.length > 0) {
            for (let i = arr.length - 1; i >= 0; i--) {
                let icon = arr[i];
                if(icon.metadata.class && icon.metadata.class.recycleObject){
                    icon.metadata.class.recycleObject(icon);
                }
            }
        }
    }
    private showPoints() {
        let hp = GlobalObject.getInstance().main.HotPoint as HotPoint;
        let posArr = [
            new Vector3(-8, 7.5, 10.5),
            new Vector3(32, 6.5, 47),
            new Vector3(-44, 4, 46.8)
        ];
        for (let i = 0; i < posArr.length; ++i) {
            let point = hp.clone() as any;
            point.name = "apt_" + i;
            this.scene.addMesh(point);
            point.setParent(this.mc as TransformNode);
            point.position = posArr[i];
            point.scaling.set(0.5, 0.5, 0.5);
            hp.addAnimation(point.getChildren()[0] as Mesh);
        }
    };
    private addPickEvent() {
        this.scene.onPointerObservable.add((e) => {
            switch (e.type) {
                case PointerEventTypes.POINTERDOWN: {
                    if (e.pickInfo && e.pickInfo.pickedMesh && this.workshopMesh?.isEnabled()) {
                        //console.log('Pick:', e.pickInfo.pickedMesh.id, e.pickInfo.pickedPoint);
                        if (e.pickInfo.pickedMesh.parent && e.pickInfo.pickedMesh.name.indexOf('facility_box') > -1) {
                            let str = e.pickInfo.pickedMesh.parent.name;
                            let id = str.substring(str.length - 7, str.length).replace("_", "-");
                            console.log(id);
                            this.openFacilityInfo(id, e.pickInfo.pickedMesh as Mesh);
                        }
                        if (e.pickInfo.pickedMesh.parent && e.pickInfo.pickedMesh.parent.name == 'lianheCam') {
                            // console.log(e.pickInfo.pickedMesh.name);
                            this.openCameraVideo(e.pickInfo.pickedMesh.name);
                        }
                    }
                    break;
                }
            }
        });
    }
    private openCameraVideo(name: string) {
        if (this.nowCamObj[name]) {
            let ipStr = this.nowCamObj[name][0];
            let nameStr = this.nowCamObj[name][1];
            let msg = { type: "openCam", data: { name: nameStr, ip: ipStr } }
            Boardcaster.getInstance().send(msg);
        }
    }
    private openFacilityInfo(id: any, mesh: Mesh, path: string = 'c/') {
        if (!this.workshopMesh?.isEnabled()) {
            return;
        }
        const date: Date = new Date();
        if ((date.getTime() - this.nowDate.getTime()) < 1000) {
            return;
        }
        this.nowDate = date;
        const data = { id: id, path: path, from: "CLianheStage" };
        this.facilityInfoBox = GlobalObject.getInstance().main.fancilityInfoBox;
        // 如果弹窗显示且id与现在的相同
        if (this.facilityInfoBox && this.facilityInfoBox.getVisible() == true) {
            //return;
        }
        this.facilityInfoBox?.addToMesh(mesh, data);
        this.facilityInfoBox?.setText();
    }
    private createCam() {
        this.nowCamObj = GlobalObject.getInstance().main.camData["联合"];
        let spriteManagerCams = new SpriteManager("camManager", this.source.camImg, 512, 512, this.scene);
        //spriteManagerCams.isPickable = true;
        let parent = this.scene.getTransformNodeByName('lianheCam');
        let m: Mesh[] = parent?.getChildMeshes() as Mesh[];
        if (m && m.length > 0) {
            m.forEach((c) => {
                if (this.nowCamObj[c.name]) {
                    let bboxCenter = c.getBoundingInfo().boundingBox.centerWorld;
                    let pos: Vector3 = new Vector3(bboxCenter.x, bboxCenter.y, bboxCenter.z);
                    let cam = new Sprite(c.name, spriteManagerCams);
                    cam.size = 2;
                    cam.position = new Vector3(pos.x, pos.y, pos.z);
                    this.camArr?.push(cam);
                }
                c.visibility = 0;
            });
        }
    }
    private camEanbled(showed: boolean) {
        this.camArr?.forEach((c) => {
            c.isPickable = showed;
            c.isVisible = showed;
        });
    }
    private showMinimap(){
        const minimap = (GlobalObject.getInstance().main.minimap as NaviMinimap);
        this.minimap = minimap;
        const rect3D = { start: new Vector3(67, 0, 89), end: new Vector3(-134, 0, 145), rangeX: -201, rangeZ: 56 }; // (x+)-(x-); (z+)-(z-)
        const rectMap = { start: new Vector3(0 - 50, 0, 36 - 50), end: new Vector3(100 - 50, 0, 65 - 50), rangeX: 100, rangeZ: 29 }; // top和left的原点在mc的矩形中心
        minimap.loadImg(this.source.miniMapImg,rect3D,rectMap);
    }

    // --------------------------------------------------------------------------------------------------------------------------------
    public onViewAngleChanged(data: any, locked: boolean = false) {
        const player = GlobalObject.getInstance().main.player;
        const camera = (GlobalObject.getInstance().main.camera as ArcRotateCamera);
        const idx: number = typeof (data) === 'number' ? data : 1;

        if (idx == 2 || idx == 3) {
            locked = true;  // 目前第2，3个视角是不能移动的固定视角
        }


        // 在漫游视角时候，可以调整camera半径
        if (idx == 4) {
            // 漫游视角
            camera.upperRadiusLimit = 15;
        } else {
            //非漫游视角
            camera.upperRadiusLimit = 0.5;
        }

        // 天空俯视固定视角 显示和隐藏厂房
        if (idx == 3) {
            this.houseMesh?.setEnabled(false);
            camera.lowerBetaLimit = 0;
            camera.upperBetaLimit = 0;
            camera.minZ = 10;
            camera.maxZ = 250;
            this.minimap?.hide();
            this.camEanbled(false);
            (this.scene.getLightByName("indoor_sun1") as DirectionalLight).intensity = 0;
            const ground_0 = this.ground_0 as Mesh;
            if (ground_0) {
                const gmat = ground_0.material as PBRMaterial;
                gmat.ambientTexture = null;
            }
        } else {
            this.houseMesh?.setEnabled(true);
            camera.lowerBetaLimit = 0;
            camera.upperBetaLimit = Math.PI * 0.53;
            camera.minZ = 0.2;
            camera.maxZ = 200;
            this.minimap?.show();
            this.camEanbled(GlobalObject.getInstance().main.camShowed as boolean || true);
            (this.scene.getLightByName("indoor_sun1") as DirectionalLight).intensity = 3;
            const ground_0 = this.ground_0 as Mesh;
            if (ground_0) {
                const gmat = ground_0.material as PBRMaterial;
                gmat.ambientTexture = this.groundAO as Texture;
            }
        }

        // 设置player的位置和camera方向
        if (player && player.player && idx < this.viewPositions.length) {
            player.locked = locked;
            const pos = this.viewPositions[idx];
            const seting = this.viewSetting[idx];
            player.player.position.set(pos.x, pos.y, pos.z);
            camera.alpha = seting[0];
            camera.beta = seting[1];
        }
    }
    public onCamChanged(data: any) {
        const camShowed = typeof (data) === 'boolean' ? data : true;
        GlobalObject.getInstance().setCamShowed(camShowed);
        this.camEanbled(GlobalObject.getInstance().main.camShowed as boolean);
    }
    public onWorkshopChanged(idx: number) {
        // idx 0-5--> 0首页 1静子 2转子 3联合 4喷涂 5配送 6总装
        //console.log("data is: " + idx);
        let data = "qwq2x";
        if (idx - 1 >= 0) {
            data = "ohp_" + (idx - 1);
        }
        const emitter = CrossEvent.getInstance().getEmitter();
        emitter.emit(CrossEvent.getInstance().STAGE_CHANGED, {
            data: data,
            descript: "切换场景",
            from: "CLianheStage",
            eventType: "CrossEvent",
        });

    }
    public reload() {
        this.stageShowed = true;
        if (this.workshopMesh) {
            this.groundMesh?.setEnabled(true);
            this.workshopMesh?.setEnabled(true);
            this.camEanbled(GlobalObject.getInstance().main.camShowed as boolean || true);
            this.houseMesh?.setEnabled(true);
            this.boxMesh?.setEnabled(true);
            this.mc.setEnabled(true);
            this.init();
        } else {

        }
    }
    public unload() {
        const player = GlobalObject.getInstance().main.player?.player as Mesh;
        this.playerData.pos = player.position.clone();
        const camera = (GlobalObject.getInstance().main.camera as ArcRotateCamera);
        this.playerData.view[0] = camera.alpha;
        this.playerData.view[1] = camera.beta;

        this.stageShowed = false;
        this.groundMesh?.setEnabled(false);
        this.workshopMesh?.setEnabled(false);
        this.camEanbled(false);
        this.houseMesh?.setEnabled(false);
        this.boxMesh?.setEnabled(false);
        this.mc.setEnabled(false);
        this.minimap?.hide();
        this.facilityInfoBox?.hide();
    }
}